import IDataSourceConfiguration from '../Types/IDataSourceConfiguration'

export const tyontekijaAlueRelationDataSourceConfiguration = (
    dataSourceMetadata: IDataSourceConfiguration
): IDataSourceConfiguration => ({
    ...dataSourceMetadata,
    DependsOn: ['TyontekijaDataSource'],
})
